import { gql } from "@apollo/client";
import { AccountFragment } from "fragments/account";
import { KeyFragment } from "fragments/key";


export const get = gql`
  query KeyGet($domain: String!, $orgId: String!, $keyId: String!) {
    viewer {
      id
      account {
        id
        ...AccountFragment
        domains {
          id
          get(domain: $domain){
            id
            organizations {
              id
              get(orgId: $orgId) {
                id
                keys {
                  id
                  get (keyId: $keyId) {
                    ...KeyFragment
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${KeyFragment}
`;


export const list = gql`
  query KeyList($domain: String!, $orgId: String!, $input: ListInput) {
    viewer {
      id
      account {
        id
        domains {
          id
          get(domain: $domain){
            id
            organizations {
              id
              get(orgId:$orgId) {
                id
                keys {
                  id
                  list(input: $input) {
                    id
                    last
                    items {
                      ...KeyFragment
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${KeyFragment}
`;

// The same listing narrowed to the keys bound to one resource — `scope:
// { service, type, id }` — or, without `id`, to any resource of that kind. A
// separate document rather than a `$scope` on `list`, so the unfiltered listing
// sends what it always did. Only the organization section's `keys.list` takes
// `scope`. docs/scoped-keys.md §Listing by scope.
export const listScoped = gql`
  query KeyListScoped($domain: String!, $orgId: String!, $input: ListInput, $scope: KeyScopeInput) {
    viewer {
      id
      account {
        id
        domains {
          id
          get(domain: $domain){
            id
            organizations {
              id
              get(orgId:$orgId) {
                id
                keys {
                  id
                  list(input: $input, scope: $scope) {
                    id
                    last
                    items {
                      ...KeyFragment
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${KeyFragment}
`;


export const create = gql`
  mutation KeyNew($domain: String!, $orgId: String!, $input: KeyInputCreate!) {
    viewer {
      account {
        domains {
          get(domain: $domain){
            organizations {
              get(orgId:$orgId) {
                keys {
                  create(input: $input) {
                    keySecret
                    ...KeyFragment
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${KeyFragment}
`;



export const remove = gql`
  mutation KeyRemove($domain: String!, $orgId: String!, $keyId: String!) {
    viewer {
      account {
        domains {
          get(domain: $domain){
            organizations {
              get(orgId:$orgId) {
                keys {
                  get(keyId: $keyId) {
                    remove
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;





export const update = ({ domain, orgId }) => (cache) => {
  Object.keys(cache.data.data).forEach((key) => {
    if (key.includes(`${domain}/${orgId}/key/queries`)) {
      cache.data.delete(key);
    }
  });
};
